import React from 'react';
interface PurchaseButtonProps {
  className?: string;
}
export function PurchaseButton({
  className = ''
}: PurchaseButtonProps) {
  const checkoutUrl = 'https://barreresuelto.impultienda.ar';
  return <a href={checkoutUrl} className={`group relative inline-flex flex-col items-center justify-center w-full max-w-md px-6 py-4 text-center text-white bg-brand-pink rounded-full shadow-glow hover:bg-opacity-90 transition-all duration-300 transform hover:scale-105 ${className}`} data-id="element-245" data-mp="3v4yujj41l1fs">
      <span className="text-lg md:text-xl font-bold uppercase tracking-wider whitespace-nowrap" data-id="element-246" data-mp="vpbnmf2ag5sm">
        Quiero mis clases resueltas
      </span>
    </a>;
}